// import { setLocation } from '@/utils/auth'

function getMyLocation() {
  var geolocation = new qq.maps.Geolocation(
    'key=IGUBZ-DGX6U-WWKV3-2UPDP-MENHS-J4FDY',
    'userLocation'
  )
  return new Promise((resolve, reject) => {
    geolocation.getLocation(
      position => {
        resolve(position)
      },
      () => {
        reject('定位失败')
        getMyLocation()
      }
    )
  })
}

class Location {
  constructor(location) {
    this.location = location
  }
  getLocation
}

const state = {
  locationInfo: ''
}

const mutations = {
  SET_LOCATION(state, info) {
    state.locationInfo = info
  }
}

const actions = {
  getLocation({ commit, state }) {
    var geolocation = new qq.maps.Geolocation(
      'key=IGUBZ-DGX6U-WWKV3-2UPDP-MENHS-J4FDY',
      'userLocation'
    )
    return new Promise((resolve, reject) => {
      geolocation.getLocation(
        position => {
          // if (!state.locationInfo) return
          commit('SET_LOCATION', position)
          resolve(position)
        },
        () => {
          reject(false)
        }
      )
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
